// extracted by mini-css-extract-plugin
export default {"toggle":"z-toggle_toggle__5ykgG","toggle__slider":"z-toggle_toggle__slider__bbYAt"};